<template>
    <div @click="focusNewTag()" :class="{'read-only': readOnly}" class="app-input-tag-wrapper">
        <span v-for="(tag, index) in innerTags" :key="index" class="input-tag">
          <span>{{ tag }}</span>
          <a v-if="!readOnly" @click.prevent.stop="remove(index)" class="remove"></a>
        </span>
        <input
            v-if="!readOnly && !isLimit"
            ref="inputtag"
            :placeholder="placeholder"
            type="text"
            v-model="newTag"
            v-on:keydown.delete.stop="removeLastTag"
            v-on:keydown="addNew"
            class="new-tag"
        />
        <input type="hidden" :name="this.name" :value="this.innerTags.join(',')" />
    </div>
</template>

<script>
const validators = {
    email: new RegExp(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    ),
    url: new RegExp(/^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i),
    text: new RegExp(/^[a-zA-Z]+$/),
    digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
    isodate: new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/),
};

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        tags: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '',
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        validate: {
            type: String,
            default: '',
        },
        addTagOnKeys: {
            type: Array,
            default: function() {
                return [
                    13, // Return
                    188, // Comma ','
                    9, // Tab
                ];
            },
        },
        limit: {
            default: -1,
        },
    },

    data() {
        return {
            newTag: '',
            innerTags: [...this.tags],
            hiddenInput: null,
        };
    },

    computed: {
        isLimit: function() {
            return this.limit > 0 && Number(this.limit) === this.innerTags.length;
        },
    },

    methods: {
        focusNewTag() {
            if (this.readOnly || !this.$el.querySelector('.new-tag')) {
                return;
            }
            this.$el.querySelector('.new-tag').focus();
        },

        addNew(e) {
            // Do nothing if the current key code is
            // not within those defined within the addTagOnKeys prop array.
            if ((e && this.addTagOnKeys.indexOf(e.keyCode) === -1) || this.isLimit) {
                return;
            }

            // We prevent default & stop propagation for all
            // keys except tabs (used to move between controls)
            if (e && (e.keyCode !== 9 || this.newTag.length > 0)) {
                e.stopPropagation();
                e.preventDefault();
            }

            if (this.newTag && this.innerTags.indexOf(this.newTag) === -1 && this.validateIfNeeded(this.newTag)) {
                this.innerTags.push(this.newTag);
                this.newTag = '';
                this.tagChange();
            }
        },

        validateIfNeeded(tagValue) {
            if (this.validate === '' || this.validate === undefined) {
                return true;
            } else if (Object.keys(validators).indexOf(this.validate) > -1) {
                return validators[this.validate].test(tagValue);
            }

            return true;
        },

        remove(index) {
            this.innerTags.splice(index, 1);
            this.tagChange();
        },

        removeLastTag() {
            if (this.newTag) {
                return;
            }
            this.innerTags.pop();
            this.tagChange();
        },

        tagChange() {
            this.$emit('update:tags', this.innerTags);
        },
    },
};
</script>

<style>
.app-input-tag-wrapper {
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    cursor: text;
    text-align: left;
    -webkit-appearance: textfield;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.app-input-tag-wrapper .input-tag {
    background-image: linear-gradient(to bottom, #d9edf7 0%, #b9def0 100%);
    border-radius: 2px;
    border: 1px solid #9acfea;
    color: #31708f;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin: 3px;
    padding: 3px 5px;
}

.app-input-tag-wrapper .input-tag .remove {
    position: relative;
    cursor: pointer;
    font-weight: bold;
    color: #31708f;
    font-size: 16px;
    line-height: 16px;
    margin: 0 1px 0 3px;
}

.app-input-tag-wrapper .input-tag .remove:hover {
    text-decoration: none;
}

.app-input-tag-wrapper .input-tag .remove::before {
    content: ' ×';
}

.app-input-tag-wrapper .new-tag {
    background: transparent;
    border: 0;
    color: #777777;
    font-size: 13px;
    font-weight: 400;
    outline: none;
    margin: 3px;
    padding: 4px 6px;
    width: auto;
}

.app-input-tag-wrapper.read-only {
    cursor: default;
}
</style>
